<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="loading$"
	closeButtonText="actions.cancel"
	confirmButtonText="actions.confirm"
>
	<ng-container slot="header">
		<h3>
			@switch (data.type) {
				@case ('Delete') {
					<div class="delete-header">
						<div class="icon-warning-box">
							<alaris-icon name="icon-warning-circle"></alaris-icon>
						</div>
						{{ 'campaigns.delete' | translate }}
					</div>
				}
				@case ('Confirm') {
					{{ 'campaigns.readyToSent' | translate }}
				}
			}
		</h3>
	</ng-container>
	<ng-container slot="content">
		<div class="note">
			@switch (data.type) {
				@case ('Delete') {
					@if (campaign.info.status === campaignStatus.SCHEDULED) {
						<p>
							{{ 'campaigns.deleteScheduledNote' | translate }}:
							<br />
							<b>{{ campaign.info.scheduled | dateFormat }}</b>
						</p>
					}
					{{ 'campaigns.deleteNote' | translate }}
				}
				@case ('Confirm') {
					<div class="about">
						<div class="dot"></div>
						{{ 'campaigns.name' | translate }}:
						<span class="bold"> {{ campaign.info.name | noValue }}</span>
					</div>
					<div class="about">
						<div class="dot"></div>
						{{ 'campaigns.recipients' | translate }}:
						<span class="bold"> {{ total }}</span>
					</div>
					<div class="about">
						<div class="dot"></div>
						{{ 'campaigns.scheduledDate' | translate }}:
						<span class="bold">
							{{ (campaign.info.scheduled | dateFormat) || ('gl.now' | translate) }}
						</span>
					</div>

					<alaris-text-area
						[formControl]="description"
						class="description"
						[errors]="errors"
						data-testid="descriptionTextarea"
					>
						{{ 'campaigns.noteForYourself' | translate }}
					</alaris-text-area>
				}
			}
		</div>
	</ng-container>
</alaris-dialog>
